// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mavFooter{padding-left:5px;padding-right:5px;font-size:.9em}", ""]);
// Exports
module.exports = exports;
